var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "headermenu" }, [
    _c(
      "div",
      { staticClass: "py-0 px-0 container" },
      [
        _c("div", { staticClass: "menubar" }, [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "v-list",
                { staticClass: "d-flex ma-0 pa-0" },
                _vm._l(_vm.menuItems, function (item, i) {
                  return _c(
                    "v-list-item",
                    { key: i, staticClass: "flex-grow-0 flex-fill" },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "dynamic-link",
                            {
                              attrs: {
                                to:
                                  item.href ||
                                  (item.children &&
                                    item.children[0] &&
                                    item.children[0].href) ||
                                  "/",
                                "append-class": {
                                  "text-reset fw-700":
                                    _vm.$route.path === item.href,
                                  "text-reset fw-500":
                                    _vm.$route.path !== item.href,
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 py-5 me-1 position-relative",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.viewSubMenu(i, "inactive")
                                    },
                                    mouseleave: function ($event) {
                                      return _vm.hideSubMenu(i)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "font",
                                    { attrs: { color: item.colors } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "icon-floating" },
                                        [
                                          _c("i", {
                                            staticClass: "las lh-1 fs-20",
                                            class: item.icon || "",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.children && item.children.length
                                        ? _c("div", { staticClass: "fs-16" }, [
                                            _vm._v(_vm._s(item.name)),
                                          ])
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "fs-16",
                                              on: {
                                                mouseenter: function ($event) {
                                                  return _vm.hideAllSubMenu()
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          item.children && item.children.length
                            ? _c(
                                "div",
                                {
                                  ref: "sub_menu" + i,
                                  refInFor: true,
                                  staticClass: "sub_menus",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.viewSubMenu(i)
                                    },
                                    mouseleave: function ($event) {
                                      return _vm.hideSubMenu(i)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "sub-wrapper" }, [
                                    _c(
                                      "div",
                                      { staticClass: "container cstm-row" },
                                      [
                                        _c("div", { staticClass: "sub-list" }, [
                                          _c("div", [
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "position-relative unstyled w-100",
                                              },
                                              _vm._l(
                                                item.children,
                                                function (sub_menu, j) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: i + "_" + j,
                                                      staticClass:
                                                        "sub-list-menus",
                                                      class: {
                                                        "no-hover":
                                                          sub_menu.children &&
                                                          sub_menu.children
                                                            .length,
                                                      },
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.showMenu(
                                                            $event,
                                                            sub_menu.children
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "dynamic-link",
                                                        {
                                                          staticClass:
                                                            "sub-list-link",
                                                          attrs: {
                                                            to:
                                                              sub_menu.href ||
                                                              "/",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                sub_menu.name
                                                              ) +
                                                              "\n                                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      sub_menu.children &&
                                                      sub_menu.children.length
                                                        ? _c("img", {
                                                            staticClass:
                                                              "sub-menu-arrow",
                                                            attrs: {
                                                              src: "/assets/img/menu-arrow.svg",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      sub_menu.children &&
                                                      sub_menu.children.length
                                                        ? _c(
                                                            "ul",
                                                            _vm._l(
                                                              sub_menu.children,
                                                              function (
                                                                sub_menu2,
                                                                k
                                                              ) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key:
                                                                      i +
                                                                      "_" +
                                                                      j +
                                                                      "_" +
                                                                      k,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "dynamic-link",
                                                                      {
                                                                        staticClass:
                                                                          "sub-list-link2",
                                                                        attrs: {
                                                                          to:
                                                                            sub_menu2.href ||
                                                                            "/",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              sub_menu2.name
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "right-side" },
                                          [
                                            _c("div", [
                                              _c("p", [
                                                _vm._v(
                                                  "\n                                                    환경친화적 인쇄를 지향하는\n                                                    "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                                    인쇄의 넘버원,\n                                                    "
                                                ),
                                                _c("strong", [
                                                  _vm._v("프리원!"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("img", {
                                                attrs: {
                                                  src: "/assets/img/soyinkmark.svg",
                                                  alt: "인증마크",
                                                },
                                              }),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center right-icons" },
            [
              _c(
                "div",
                { staticClass: "icon-item" },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        attach: "",
                        bottom: "",
                        transition: "slide-y-transition",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "text-reset",
                                  attrs: { href: "/after-login/" },
                                },
                                [
                                  _c(
                                    "i",
                                    _vm._g(
                                      _vm._b(
                                        { staticClass: "las la-home" },
                                        "i",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_vm._v(" "), _c("span", [_vm._v("홈")])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.$optional("data.logobar_menu?.labels"),
                function (menu, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "icon-item" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            attach: "",
                            bottom: "",
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "text-reset",
                                        attrs: {
                                          to: _vm.$optional(
                                            "data.logobar_menu.links"
                                          )[i],
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "las",
                                                class: _vm.$optional(
                                                  "data.logobar_menu.icons"
                                                )[i],
                                              },
                                              "i",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm.getCartCount > 0 &&
                                            _vm.$optional(
                                              "data.logobar_menu.links"
                                            )[i] === "/cart"
                                              ? _c("v-badge", {
                                                  staticClass: "icon-badge",
                                                  staticStyle: {
                                                    left: "1325px",
                                                    top: "-12px",
                                                  },
                                                  attrs: {
                                                    color: "error",
                                                    content: _vm.getCartCount,
                                                    inline: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_vm._v(" "), _c("span", [_vm._v(_vm._s(menu))])]
                      ),
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              !_vm.isAuthenticated
                ? _c(
                    "div",
                    { staticClass: "icon-item" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            attach: "",
                            bottom: "",
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "text-reset",
                                        attrs: { to: { name: "Login" } },
                                      },
                                      [
                                        _c(
                                          "i",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "las la-sign-in-alt",
                                              },
                                              "i",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            425843929
                          ),
                        },
                        [_vm._v(" "), _c("span", [_vm._v("로그인")])]
                      ),
                    ],
                    1
                  )
                : [
                    _c("div", { staticClass: "user-info-bar" }, [
                      _c("span", { staticClass: "user-name" }, [
                        _vm._v(_vm._s(_vm.currentUser.name)),
                      ]),
                      _vm.currentUserCompany.company_name
                        ? _c("span", { staticClass: "user-company" }, [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.currentUserCompany.company_name) +
                                ")"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "icon-item" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              attach: "",
                              bottom: "",
                              transition: "slide-y-transition",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "text-reset",
                                        attrs: { to: { name: "Logout" } },
                                      },
                                      [
                                        _c(
                                          "i",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "las la-sign-out-alt",
                                              },
                                              "i",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [_vm._v(" "), _c("span", [_vm._v("로그아웃")])]
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("FullCategories", {
          ref: "fullCategories",
          attrs: { show: _vm.isFullCategories },
          on: { close: _vm.closeFullCategories },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }